<main class="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden py-4 [padding-inline:var(--shell-pad-x)]">
  <div class="grid min-h-0 flex-1 grid-rows-[auto_minmax(0,1fr)] gap-4 lg:grid-cols-[14rem_minmax(0,1fr)] lg:grid-rows-1">
    <app-ui-module-sidebar [items]="navItems" ariaLabel="Configurações" />

    <section class="min-h-0 min-w-0 overflow-y-auto overflow-x-hidden pr-1">
      <router-outlet />
    </section>
  </div>
</main>
